"use client"

import { Details } from "./Details"
import { XMarkIcon } from "@heroicons/react/20/solid"
import clsx from "clsx"
import Link from "next/link"

function FaqComponent(){


    const items = [
        {
          title: "Est-ce que la plateforme heelio remplace mon logiciel comptable ou mon expert-comptable ?",
          content:
            "Non, heelio est un logiciel qui agrège toutes les données financières et opérationnelles (arrive bientôt) de l’entreprise. Il aspire les données comptables notamment en se connectant à votre logiciel comptable. Heelio ne fait pas la comptabilité, ça c’est le rôle de votre expert-comptable. Nous sommes complémentaires à votre expert-comptable.",
        },
        {
          title: "Quelle différence y a-t-il entre mon expert-comptable et mon DAF heelio ?",
          content:
            "Votre expert-comptable : <br></br>- Établit votre comptabilité (en général une fois par an) \n\n- Réalise le dépôt de vos comptes annuels au greffe du tribunal \n\n- Réalise vos déclarations de TVA et autres taxes (IS, CVA/CFE, etc.) \n\n- Établit vos bulletins de paie (pas systématique) \n\n- Etc.",
        },
        {
          title: "Combien ça coûte heelio ?",
          content:
            "",
        },
        {
          title: "Est-ce que mon DAF heelio s’occupe de mes tâches administratives (facturation client,paiement fournisseur, recouvrement client, etc.) ?",
          content:
            <div>
                <p>Non.</p>
                <p>Car beaucoup de logiciels sur le marché automatisent très bien ces tâches. Néanmoins nous avons des partenaires avec qui nous travaillons qui peuvent s’en charger (notamment sur le recouvrement client).</p>
                <p>En revanche votre DAF heelio peut superviser ces tâches :</p>
                <ul className="list-disc ml-10 mb-5">
                    <li>S’assurer que la facturation client a bien été faite</li>
                    <li>Faire un point sur le recouvrement client</li>
                    <li>Vérifier que les fournisseurs ont bien été payés</li>
                    <li>S’assurer que votre expert-comptable dispose des données pour établir vos déclarations de TVA ou autres</li>
                    <li>Etc.</li>
                </ul>
            </div>,
        },
      ]



    return(
        <div className="flex justify-center items-center flex-col select-none px-5 text-[#042040]">


<h4 className="font-bold text-[#042040] text-center mt-10 text-3xl md:text-5xl max-w-[980px] mx-auto leading-10 md:leading-[4rem] lg:leading-[5rem]">Besoin de <p className="relative inline-block">
                  <span className="bg-[#FED90F] w-[165px] md:w-[260px] h-10 md:h-16 absolute top-0 md:top-1.5 -left-1.5 md:-left-2 z-1 rounded-lg transform rotate-[-2deg]"></span>
                  <span className="relative">précisions</span>
                </p> ?</h4>












            <p className="text-lg md:text-xl leading-8 text-[#042040] text-center">
           Posez-nous toutes vos questions!
            </p>

            <div className="flex px-8 pt-12 md:px-0">
                <Details className="mx-auto max-w-2xl space-y-5">
                    {items.map((item, index) => (
                    <Details.Item
                        key={index}
                        className="group rounded-2xl border transition duration-500 hover:bg-[#FED90F]/[0.075]">
                        {({ isActive, toggle }) => (
                        <>
                            <div className="flex cursor-pointer items-center p-4" onClick={toggle}>
                            <div className="grow text-[#042040]/75 transition group-hover:text-[#042040]">{item.title}</div>

                            <div className="relative ml-10">
                                <XMarkIcon
                                className={clsx(
                                    { "rotate-180": isActive, "rotate-45": !isActive },
                                    "h-6 w-6 text-[#042040]/50 transition-transform duration-500 ",
                                )}
                                />
                            </div>
                            </div>

                            <Details.Content className="overflow-hidden px-4 transition-all duration-500 will-change-[height] pr-12">
                            <div className="pb-4 font-light leading-relaxed tracking-wide text-[#042040]/75">{index == 1 ? 
                            <>Votre expert-comptable : 
                                <ul className="list-disc ml-10 mb-5">
                                    <li>Établit votre comptabilité (en général une fois par an)</li>
                                    <li>Réalise le dépôt de vos comptes annuels au greffe du tribunal</li>
                                    <li>Réalise vos déclarations de TVA et autres taxes (IS, CVA/CFE, etc.)</li>
                                    <li>Établit vos bulletins de paie (pas systématique)</li>
                                    <li>Etc.</li>
                                </ul>
                                Votre DAF heelio construit avec vous votre stratégie financière, concrètement il :
                                <ul className="list-disc ml-10 mb-5">
                                    <li>Construit et met à jour votre reporting financier adapté à votre activité (suivi de trésorerie, compte de résultat analytique, suivi des créances et des dettes, etc.)</li>
                                    <li>Construit votre prévisionnel financier</li>
                                    <li>Analyse votre performance financière avec vous</li>
                                    <li>Vous fait des recommandations pour optimiser votre trésorerie et votre rentabilité</li>
                                    <li>Vous aide à résoudre vos problématiques : recouvrement client, besoin de financements (dilutif et non dilutif), etc.</li>
                                    <li>Vous accompagne dans les moments clés : levée de fonds, acquisition / cession, etc.</li>
                                </ul>
                                Votre DAF heelio est votre business partner.
                            </>
                            
                            : index == 2 ? 
                                <>Pas cher 😉 plus sérieusement nous vous indiquerons nos tarifs lors de nos échanges.
                                Néanmoins ce que l’on peut vous dire : 
                                    <ul className="list-disc ml-10 mb-5">
                                        <li>Nous sommes moins cher qu’un DAF externalisé « classique »</li>
                                        <li>Notre offre est sans engagement (vous arrêtez quand vous le souhaitez)</li>
                                        <li>Notre tarif dépend de la taille de l’entreprise et du scope d’intervention de nos DAF (récurrent, non récurrent ou les deux)</li>
                                    </ul>
                                </>
                            
                            : item.content}</div>
                            </Details.Content>
                        </>
                        )}
                    </Details.Item>
                    ))}
                </Details>
            </div>
            

            <p className="text-sm md:text-md leading-8 text-[#042040] text-center mb-24 mt-5">
           Vous avez d&apos;autres questions ? consultez notre <Link href={"/faq"} className="underline-offset-4 underline decoration-[#FED90F] decoration-4 cursor-pointer">F.A.Q</Link>
            </p>


        </div>

    )
}

export default FaqComponent;